import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Logo from '../components/Logo';

const API_ENDPOINTS = {
  giftGetRegistrations: 'https://gift-get-registrations-336444799661.us-central1.run.app/giftGetRegistrations',
  giftApproveRegistration: 'https://gift-approveregistration-336444799661.us-central1.run.app/giftApproveRegistration',
  giftGetCouples: 'https://gift-getcouples-336444799661.us-central1.run.app', // Cuando la crees
  giftRejectRegistration: 'https://gift-reject-registration-336444799661.us-central1.run.app/giftRejectRegistration', // Cuando la crees
  giftGetRejectedRegistrations: 'https://gift-get-rejected-336444799661.us-central1.run.app/giftGetRejectedRegistrations', // ← Agregar después
  giftDeleteCouple: 'https://gift-deletecouple-336444799661.us-central1.run.app/giftDeleteCouple', // ← Nuevo
};
const API_URL = 'https://us-central1-easymenu-457215.cloudfunctions.net';


const AdminPanel = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [activeTab, setActiveTab] = useState('pending');
  const [pendingRegistrations, setPendingRegistrations] = useState([]);
  const [approvedEvents, setApprovedEvents] = useState([]);
  const [rejectedRegistrations, setRejectedRegistrations] = useState([]); // ← Nuevo

  const [selectedRegistration, setSelectedRegistration] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [createFormData, setCreateFormData] = useState({
    weddingDate: '',
    customSlug: '',
    slugDateOption: 'party' // ✅ Nuevo: 'party' | 'ceremony' | 'none'
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCouple, setSelectedCouple] = useState(null);
  const [creatingEvent, setCreatingEvent] = useState(false);

// 1) dejá tu efecto actual para cuando entres al tab (opcional)
// 2) agregá este otro para precargar una vez
useEffect(() => {
  const preloadApproved = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_ENDPOINTS.giftGetCouples}/giftGetCouples`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      if (data.success) setApprovedEvents(data.data);
    } catch (e) {
      console.error("Error preloading approved events:", e);
    }
  };

  preloadApproved();
}, []);

  // Helper para generar slug inicial
  // const generateSlug = (reg) => {
  //   if (!reg) return '';
  //   return `${reg.brideName.toLowerCase()}-y-${reg.groomName.toLowerCase()}`
  //     .normalize("NFD")
  //     .replace(/[\u0300-\u036f]/g, "")
  //     .replace(/[^a-z0-9-]/g, "")
  //     .replace(/--+/g, "-");
  // };

  // Helper para generar slug inicial CON DÍA-MES-AÑO
  // const generateSlug = (reg) => {
  //   if (!reg) return '';

  //   // ✅ Parsear directamente el string (evita problemas de timezone)
  //   const [year, month, day] = reg.weddingDate.split('-');

  //   return `${reg.brideName.toLowerCase()}-y-${reg.groomName.toLowerCase()}-${day}-${month}-${year}`
  //     .normalize("NFD")
  //     .replace(/[\u0300-\u036f]/g, "")
  //     .replace(/[^a-z0-9-]/g, "")
  //     .replace(/--+/g, "-");
  // };

  const generateSlug = (reg, dateOption = 'party') => {
    if (!reg) return '';

    const baseName = `${reg.brideName.toLowerCase()}-y-${reg.groomName.toLowerCase()}`;

    // Si no quiere fecha en el slug
    if (dateOption === 'none') {
      return baseName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/--+/g, "-");
    }

    // Determinar qué fecha usar
    let dateToUse = reg.weddingDate; // fallback

    if (dateOption === 'party' && reg.partyDate) {
      dateToUse = reg.partyDate;
    } else if (dateOption === 'ceremony' && reg.ceremonyDate) {
      dateToUse = reg.ceremonyDate;
    }

    // Si no hay fecha válida
    if (!dateToUse) {
      return baseName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9-]/g, "")
        .replace(/--+/g, "-");
    }

    const [year, month, day] = dateToUse.split('-');

    return `${baseName}-${day}-${month}-${year}`
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/--+/g, "-");
  };

  // Helper para sanitizar mientras el usuario escribe
  const sanitizeSlugInput = (slug) => {
    return slug.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/--+/g, "-");
    // ❌ NO quitar guiones al final aquí (para poder escribir)
  };

  // Helper para sanitizar al enviar (versión final)
  const sanitizeSlugFinal = (slug) => {
    return slug.toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/--+/g, "-")
      .replace(/^-+|-+$/g, "");
    // ✅ Solo al enviar, quita guiones al inicio/final
  };

  // ✅ Nuevo useEffect para rejected
  useEffect(() => {
    const fetchRejectedRegistrations = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(API_ENDPOINTS.giftGetRejectedRegistrations, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        if (data.success) {
          setRejectedRegistrations(data.data);
        }
      } catch (error) {
        console.error('Error fetching rejected registrations:', error);
      }
    };

    if (activeTab === 'rejected') {
      fetchRejectedRegistrations();
    }
  }, [activeTab]);


  // Fetch pending registrations
  useEffect(() => {
    const fetchPendingRegistrations = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(`${API_ENDPOINTS.giftGetRegistrations}?status=pending`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        if (data.success) {
          setPendingRegistrations(data.data);
        }
      } catch (error) {
        console.error('Error fetching pending registrations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPendingRegistrations();
  }, []);

  // Fetch approved events
  // Fetch approved events
  useEffect(() => {
    const fetchApprovedEvents = async () => {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(`${API_ENDPOINTS.giftGetCouples}/giftGetCouples`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        // ✅ Ver qué trae la API
        console.log('📦 API Response:', data);
        // console.log('👥 Eventos cargados:', data.data);

        if (data.success) {
          setApprovedEvents(data.data);

          // ✅ Ver el primer evento con detalle
          if (data.data.length > 0) {
            // console.log('🔍 Primer evento:', data.data[0]);
            // console.log('📧 Email del primer evento:', data.data[0].email);
          }
        }
      } catch (error) {
        console.error('Error fetching approved events:', error);
      }
    };

    if (activeTab === 'approved') {
      fetchApprovedEvents();
    }
  }, [activeTab]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleDeleteCouple = async () => {
    if (!selectedCouple) return;

    // ✅ 1. Ver qué datos tiene selectedCouple
    // console.log('🔍 selectedCouple:', selectedCouple);
    // console.log('📧 selectedCouple.email:', selectedCouple.email);

    try {
      const token = localStorage.getItem('token');

      const response = await fetch(API_ENDPOINTS.giftDeleteCouple, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ coupleId: selectedCouple.id })
      });

      const data = await response.json();

      if (data.success) {
        // Remover de la lista
        setApprovedEvents(approvedEvents.filter(e => e.id !== selectedCouple.id));

        // Cerrar modal
        setShowDeleteModal(false);
        setSelectedCouple(null);

        alert(`✅ Pareja eliminada exitosamente.\n\n` +
          `Regalos eliminados: ${data.deletedGifts}\n` +
          `Regalos recibidos eliminados: ${data.deletedReceivedGifts}`);
      } else {
        alert('❌ Error al eliminar la pareja: ' + data.error);
      }
    } catch (error) {
      console.error('Error deleting couple:', error);
      alert('❌ Error al eliminar la pareja');
    }
  };

  // const handleApprove = (registration) => {
  //   setSelectedRegistration(registration);
  //   setCreateFormData({
  //     weddingDate: registration.weddingDate,
  //     customSlug: generateSlug(registration) // ← Auto-genera el slug
  //   });
  //   setShowCreateModal(true);
  // };
  const handleApprove = (registration) => {
    setSelectedRegistration(registration);

    // Determinar opción default (fiesta si existe, sino ceremonia)
    const defaultOption = registration.partyDate ? 'party' : 'ceremony';

    setCreateFormData({
      weddingDate: registration.partyDate || registration.ceremonyDate || registration.weddingDate,
      customSlug: generateSlug(registration, defaultOption),
      slugDateOption: defaultOption
    });
    setShowCreateModal(true);
  };

  // const handleCreateEvent = async (e) => {
  //   e.preventDefault();
  //   if (creatingEvent) return;          // ✅ evita doble submit
  //   setCreatingEvent(true);             // ✅ lock frontend
  //   // ✅ Sanitizar versión final antes de enviar
  //   const finalSlug = sanitizeSlugFinal(createFormData.customSlug);

  //   if (finalSlug.length < 3) {
  //     alert('❌ La URL debe tener al menos 3 caracteres');
  //     setCreatingEvent(false);   // ✅ desbloquear
  //     return;
  //   }


  //   try {
  //     const token = localStorage.getItem('token');

  //     const response = await fetch(API_ENDPOINTS.giftApproveRegistration, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': `Bearer ${token}`
  //       },
  //       body: JSON.stringify({
  //         registrationId: selectedRegistration.id,
  //         weddingDate: createFormData.weddingDate,
  //         customSlug: finalSlug // ← Usar slug final sanitizado
  //       })
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       // Remove from pending
  //       setPendingRegistrations(pendingRegistrations.filter(r => r.id !== selectedRegistration.id));

  //       // Close modal
  //       setShowCreateModal(false);
  //       setSelectedRegistration(null);

  //       // Switch to approved tab
  //       setActiveTab('approved');

  //       // Show success message
  //       alert('Evento creado exitosamente. Se envió un email a la pareja con las credenciales.');
  //     } else {
  //       alert('Error al crear el evento: ' + data.error);
  //     }
  //   } catch (error) {
  //     console.error('Error creating event:', error);
  //     alert('Error al crear el evento');
  //   } finally {
  //     setCreatingEvent(false);          // ✅ libera
  //   }
  // };

const handleCreateEvent = async (e) => {
  e.preventDefault();
  if (creatingEvent) return;
  setCreatingEvent(true);

  const finalSlug = sanitizeSlugFinal(createFormData.customSlug);

  if (finalSlug.length < 3) {
    alert('❌ La URL debe tener al menos 3 caracteres');
    setCreatingEvent(false);
    return;
  }

  try {
    const token = localStorage.getItem('token');

    // ✅ Crear AbortController para timeout manual
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 segundos

    const response = await fetch(API_ENDPOINTS.giftApproveRegistration, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        registrationId: selectedRegistration.id,
        weddingDate: createFormData.weddingDate,
        customSlug: finalSlug
      }),
      signal: controller.signal // ✅ Agregar señal de timeout
    });

    clearTimeout(timeoutId); // ✅ Limpiar timeout si responde

    // ✅ Chequear status HTTP
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();

    // ✅ Log para debug
    console.log('📦 Backend response:', data);

    if (data.success) {
      // Remove from pending
      setPendingRegistrations(pendingRegistrations.filter(r => r.id !== selectedRegistration.id));

      // Close modal
      setShowCreateModal(false);
      setSelectedRegistration(null);

      // Switch to approved tab
      setActiveTab('approved');

      // Show success message
      alert('✅ Evento creado exitosamente. Se envió un email a la pareja con las credenciales.');
    } else {
      alert('❌ Error al crear el evento: ' + data.error);
    }
  } catch (error) {
    console.error('❌ Error creating event:', error);

    // ✅ Mensajes específicos según el tipo de error
    if (error.name === 'AbortError') {
      alert('⏱️ La operación tardó demasiado (más de 30 segundos). Esto puede pasar si la función estaba inactiva. Probá de nuevo, debería ser más rápido.');
    } else if (error.message.includes('Failed to fetch')) {
      alert('🌐 Error de conexión. Verificá tu internet e intentá de nuevo.');
    } else if (error.message.includes('HTTP')) {
      alert('❌ Error del servidor: ' + error.message);
    } else {
      alert('❌ Error al crear el evento: ' + error.message);
    }
  } finally {
    setCreatingEvent(false);
  }
};

const handleReject = async (id) => {
    if (!window.confirm('¿Seguro que querés rechazar esta solicitud?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');

      const response = await fetch(`${API_ENDPOINTS.giftRejectRegistration}/giftRejectRegistration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ registrationId: id })
      });

      const data = await response.json();

      if (data.success) {
        setPendingRegistrations(pendingRegistrations.filter(r => r.id !== id));
      } else {
        alert('Error al rechazar la solicitud: ' + data.error);
      }
    } catch (error) {
      console.error('Error rejecting registration:', error);
      alert('Error al rechazar la solicitud');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-500"></div>
      </div>
    );
  }

  const formatDateShort = (value) => {
    if (!value) return "—";
    // value viene como "YYYY-MM-DD"
    return new Date(value + "T12:00:00").toLocaleDateString("es-AR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const getCeremonyDate = (event) =>
    event?.eventDetails?.ceremony?.date || event?.weddingDate || null;

  const getPartyDate = (event) =>
    event?.eventDetails?.party?.date || event?.weddingDate || null;

  return (
    <div className="min-h-screen bg-neutral-50">
      <header className="bg-white shadow-sm border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div>
              <Logo className="h-9 sm:h-10" />

              <h1 className="text-2xl font-display font-bold text-neutral-900 mt-2">
                Panel de Administración
              </h1>
            </div>
            <button
              onClick={handleLogout}
              className="bg-neutral-100 text-neutral-700 px-4 py-2 rounded-lg hover:bg-neutral-200 transition-colors"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>

      <div className="bg-white border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-8">
            <button
              onClick={() => setActiveTab('pending')}
              className={`py-4 px-2 border-b-2 font-medium transition-colors ${activeTab === 'pending'
                ? 'border-accent-500 text-accent-600'
                : 'border-transparent text-neutral-500 hover:text-neutral-700'
                }`}
            >
              Solicitudes Pendientes ({pendingRegistrations.length})
            </button>
            <button
              onClick={() => setActiveTab('approved')}
              className={`py-4 px-2 border-b-2 font-medium transition-colors ${activeTab === 'approved'
                ? 'border-accent-500 text-accent-600'
                : 'border-transparent text-neutral-500 hover:text-neutral-700'
                }`}
            >
              Eventos Activos ({approvedEvents.length})
            </button>
            <button
              onClick={() => setActiveTab('rejected')}
              className={`py-4 px-2 border-b-2 font-medium transition-colors ${activeTab === 'rejected'
                ? 'border-accent-500 text-accent-600'
                : 'border-transparent text-neutral-500 hover:text-neutral-700'
                }`}
            >
              Rechazadas ({rejectedRegistrations.length})
            </button>
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {activeTab === 'pending' && (
          <div className="space-y-6">
            <h2 className="text-xl font-display font-semibold text-neutral-900">
              Solicitudes de Registro Pendientes
            </h2>

            {pendingRegistrations.length === 0 ? (
              <div className="bg-white rounded-xl p-12 text-center">
                <div className="text-6xl mb-4">✓</div>
                <p className="text-xl text-neutral-600">No hay solicitudes pendientes</p>
              </div>
            ) : (
              <div className="grid gap-6">
                {pendingRegistrations.map(reg => (
                  <div key={reg.id} className="bg-white rounded-xl shadow-md p-6">
                    <div className="flex justify-between items-start mb-4">
                      <div>
                        <h3 className="text-2xl font-display font-bold text-neutral-900">
                          {reg.brideName} {reg.brideLastName} & {reg.groomName} {reg.groomLastName}
                        </h3>
                        <p className="text-sm text-neutral-500 mt-1">
                          Solicitud recibida: {new Date(reg.createdAt).toLocaleDateString('es-AR')}
                        </p>
                      </div>
                      <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-semibold">
                        Pendiente
                      </span>
                    </div>

                    {/* Reemplazar este bloque */}
                    <div className="grid md:grid-cols-2 gap-4 mb-6">
                      <div>
                        <p className="text-sm text-neutral-500">Email</p>
                        <p className="font-medium">{reg.email}</p>
                      </div>
                      <div>
                        <p className="text-sm text-neutral-500">Celular</p>
                        <p className="font-medium">{reg.celular}</p>
                      </div>

                      {/* ✅ Fecha Ceremonia */}
                      <div>
                        <p className="text-sm text-neutral-500">Fecha Ceremonia</p>
                        <p className="font-medium">
                          {reg.ceremonyDate
                            ? new Date(reg.ceremonyDate + 'T12:00:00').toLocaleDateString('es-AR', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })
                            : new Date(reg.weddingDate + 'T12:00:00').toLocaleDateString('es-AR', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })
                          }
                        </p>
                      </div>

                      {/* ✅ Fecha Fiesta */}
                      <div>
                        <p className="text-sm text-neutral-500">Fecha Fiesta</p>
                        <p className="font-medium">
                          {reg.partyDate
                            ? new Date(reg.partyDate + 'T12:00:00').toLocaleDateString('es-AR', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric'
                            })
                            : <span className="text-neutral-400 italic">Mismo día</span>
                          }
                        </p>
                      </div>

                      <div>
                        <p className="text-sm text-neutral-500">¿Cómo nos conoció?</p>
                        <p className="font-medium capitalize">{reg.howDidYouHear}</p>
                      </div>
                    </div>

                    {/* ✅ Mensaje (si existe) */}
                    {reg.message && (
                      <div className="mb-6 bg-neutral-50 border border-neutral-200 rounded-lg p-4">
                        <p className="text-sm text-neutral-500 mb-1">Mensaje</p>
                        <p className="text-neutral-700 italic">"{reg.message}"</p>
                      </div>
                    )}

                    <div className="flex gap-3">
                      <button
                        onClick={() => handleApprove(reg)}
                        className="flex-1 bg-accent-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-accent-600 transition-colors"
                      >
                        ✓ Aprobar y Crear Evento
                      </button>
                      <button
                        onClick={() => handleReject(reg.id)}
                        className="px-6 py-3 border-2 border-red-500 text-red-600 rounded-lg font-semibold hover:bg-red-50 transition-colors"
                      >
                        ✕ Rechazar
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* ... pending tab ... */}
          {/* ... approved tab ... */}

          {/* ✅ Nuevo tab rejected */}
          {activeTab === 'rejected' && (
            <div className="space-y-6">
              <h2 className="text-xl font-display font-semibold text-neutral-900">
                Solicitudes Rechazadas
              </h2>

              {rejectedRegistrations.length === 0 ? (
                <div className="bg-white rounded-xl p-12 text-center">
                  <div className="text-6xl mb-4">📋</div>
                  <p className="text-xl text-neutral-600">No hay solicitudes rechazadas</p>
                </div>
              ) : (
                <div className="grid gap-6">
                  {rejectedRegistrations.map(reg => (
                    <div key={reg.id} className="bg-white rounded-xl shadow-md p-6 opacity-75">
                      <div className="flex justify-between items-start mb-4">
                        <div>
                          <h3 className="text-2xl font-display font-bold text-neutral-900">
                            {reg.brideName} {reg.brideLastName} & {reg.groomName} {reg.groomLastName}
                          </h3>
                          <p className="text-sm text-neutral-500 mt-1">
                            Rechazada: {new Date(reg.processedAt).toLocaleDateString('es-AR')}
                          </p>
                        </div>
                        <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-semibold">
                          Rechazada
                        </span>
                      </div>

                      {/* En el map de rejectedRegistrations */}
                      <div className="grid md:grid-cols-2 gap-4">
                        <div>
                          <p className="text-sm text-neutral-500">Email</p>
                          <p className="font-medium">{reg.email}</p>
                        </div>
                        <div>
                          <p className="text-sm text-neutral-500">Celular</p>
                          <p className="font-medium">{reg.celular}</p>
                        </div>
                        <div>
                          <p className="text-sm text-neutral-500">Fecha Ceremonia</p>
                          <p className="font-medium">
                            {reg.ceremonyDate
                              ? new Date(reg.ceremonyDate + 'T12:00:00').toLocaleDateString('es-AR', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              })
                              : new Date(reg.weddingDate + 'T12:00:00').toLocaleDateString('es-AR', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              })
                            }
                          </p>
                        </div>
                        <div>
                          <p className="text-sm text-neutral-500">Fecha Fiesta</p>
                          <p className="font-medium">
                            {reg.partyDate
                              ? new Date(reg.partyDate + 'T12:00:00').toLocaleDateString('es-AR', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              })
                              : <span className="text-neutral-400 italic">Mismo día</span>
                            }
                          </p>
                        </div>
                        <div>
                          <p className="text-sm text-neutral-500">¿Cómo nos conoció?</p>
                          <p className="font-medium capitalize">{reg.howDidYouHear}</p>
                        </div>
                      </div>

                      {/* Mensaje si existe */}
                      {reg.message && (
                        <div className="mt-4 bg-neutral-50 border border-neutral-200 rounded-lg p-4">
                          <p className="text-sm text-neutral-500 mb-1">Mensaje</p>
                          <p className="text-neutral-700 italic">"{reg.message}"</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </main>
        {activeTab === 'approved' && (
          <div className="space-y-6">
            <h2 className="text-xl font-display font-semibold text-neutral-900">
              Eventos Activos
            </h2>

          <div className="card">
  <div className="w-full overflow-x-auto">
    <table className="min-w-[900px] w-full">
                <thead className="bg-neutral-50 border-b border-neutral-200">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase">
                      Pareja
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase">
                      Fecha Ceremonia
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase">
                      Fecha Fiesta
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase">
                      Link
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase">
                      Creado
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase">
                      Estado
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase">
                      Acción
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-neutral-200">
                  {approvedEvents.map(event => (
                    <tr key={event.id} className="hover:bg-neutral-50">
                      <td className="px-6 py-4">
                        <div className="font-medium text-neutral-900">
                          {event.brideName} {event.brideLastName || ""} & {event.groomName} {event.groomLastName || ""}
                        </div>
                      </td>
                      <td className="px-6 py-4 text-neutral-600 whitespace-nowrap">
                        {formatDateShort(getCeremonyDate(event))}
                      </td>

                      <td className="px-6 py-4 text-neutral-600 whitespace-nowrap">
                        {event?.eventDetails?.party?.date
                          ? formatDateShort(event.eventDetails.party.date)
                          : (
                            <span className="text-neutral-400 italic">
                              {event?.eventDetails?.ceremony?.date ? "Mismo día" : "—"}
                            </span>
                          )
                        }
                      </td>
                      <td className="px-6 py-4">
                        <a
                          href={`/lista/${event.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-accent-600 hover:text-accent-700 font-mono text-sm"
                        >
                          /lista/{event.id}
                        </a>
                      </td>

                      <td className="px-6 py-4 text-neutral-600">
                        {event.createdAt ? new Date(event.createdAt).toLocaleDateString('es-AR') : '-'}
                      </td>
                      <td className="px-6 py-4">
                        <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-semibold">
                          Activo
                        </span>
                      </td>
                      <td className="px-6 py-4 text-right">
                        <button
                          onClick={() => {
                            setSelectedCouple(event);
                            setShowDeleteModal(true);
                          }}
                          className="text-red-600 hover:text-red-800 font-medium text-sm"
                        >
                          🗑️ Eliminar
                        </button>
                      </td>


                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>   </div>
        )}
      </main>

      {/* Modal actualizado: */}
      {showCreateModal && selectedRegistration && (
        <div className="modal-overlay"
          onClick={() => {
            if (!creatingEvent) setShowCreateModal(false);
          }}
        >
          <div
            className="bg-white max-h-[90vh] overflow-y-auto rounded-2xl shadow-2xl max-w-2xl w-full mx-4 p-8 animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-3xl font-display font-bold text-neutral-900 mb-6">
              Crear Evento
            </h2>

            <div className="bg-accent-50 border border-accent-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-accent-900">
                <strong>Pareja:</strong> {selectedRegistration.brideName} & {selectedRegistration.groomName}
              </p>
            </div>

            <form onSubmit={handleCreateEvent} className="space-y-6">
              {/* ✅ Selector de fecha para el slug */}
              <div>
                <label className="block text-sm font-medium text-neutral-700 mb-2">
                  Fecha en la URL
                </label>
                <div className="space-y-2">
                  {/* Opción Fiesta */}
                  <label className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-neutral-50 ${createFormData.slugDateOption === 'party' ? 'border-accent-500 bg-accent-50' : 'border-neutral-200'
                    }`}>
                    <input
                      type="radio"
                      name="slugDateOption"
                      value="party"
                      checked={createFormData.slugDateOption === 'party'}
                      onChange={(e) => {
                        setCreateFormData({
                          ...createFormData,
                          slugDateOption: 'party',
                          customSlug: generateSlug(selectedRegistration, 'party')
                        });
                      }}
                      className="w-4 h-4 text-accent-600"
                    />
                    <div className="flex-1">
                      <p className="font-medium text-neutral-900">Fecha de la fiesta</p>
                      <p className="text-sm text-neutral-500">
                        {selectedRegistration.partyDate
                          ? new Date(selectedRegistration.partyDate + 'T12:00:00').toLocaleDateString('es-AR')
                          : <span className="italic">No especificada (usará ceremonia)</span>}
                      </p>
                    </div>
                  </label>

                  {/* Opción Ceremonia */}
                  <label className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-neutral-50 ${createFormData.slugDateOption === 'ceremony' ? 'border-accent-500 bg-accent-50' : 'border-neutral-200'
                    }`}>
                    <input
                      type="radio"
                      name="slugDateOption"
                      value="ceremony"
                      checked={createFormData.slugDateOption === 'ceremony'}
                      onChange={(e) => {
                        setCreateFormData({
                          ...createFormData,
                          slugDateOption: 'ceremony',
                          customSlug: generateSlug(selectedRegistration, 'ceremony')
                        });
                      }}
                      className="w-4 h-4 text-accent-600"
                    />
                    <div className="flex-1">
                      <p className="font-medium text-neutral-900">Fecha de la ceremonia</p>
                      <p className="text-sm text-neutral-500">
                        {new Date((selectedRegistration.ceremonyDate || selectedRegistration.weddingDate) + 'T12:00:00').toLocaleDateString('es-AR')}
                      </p>
                    </div>
                  </label>

                  {/* Opción Sin fecha */}
                  <label className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-neutral-50 ${createFormData.slugDateOption === 'none' ? 'border-accent-500 bg-accent-50' : 'border-neutral-200'
                    }`}>
                    <input
                      type="radio"
                      name="slugDateOption"
                      value="none"
                      checked={createFormData.slugDateOption === 'none'}
                      onChange={(e) => {
                        setCreateFormData({
                          ...createFormData,
                          slugDateOption: 'none',
                          customSlug: generateSlug(selectedRegistration, 'none')
                        });
                      }}
                      className="w-4 h-4 text-accent-600"
                    />
                    <div className="flex-1">
                      <p className="font-medium text-neutral-900">Sin fecha</p>
                      <p className="text-sm text-neutral-500">Solo nombres de la pareja</p>
                    </div>
                  </label>

                  {/* ✅ Opción Personalizado */}
                  <label className={`flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-neutral-50 ${createFormData.slugDateOption === 'custom' ? 'border-accent-500 bg-accent-50' : 'border-neutral-200'
                    }`}>
                    <input
                      type="radio"
                      name="slugDateOption"
                      value="custom"
                      checked={createFormData.slugDateOption === 'custom'}
                      onChange={(e) => {
                        setCreateFormData({
                          ...createFormData,
                          slugDateOption: 'custom'
                          // No cambiar el slug, dejarlo como está para edición manual
                        });
                      }}
                      className="w-4 h-4 text-accent-600"
                    />
                    <div className="flex-1">
                      <p className="font-medium text-neutral-900">Personalizado</p>
                      <p className="text-sm text-neutral-500">Escribir URL manualmente</p>
                    </div>
                  </label>
                </div>
              </div>

              {/* ✅ Campo editable para el slug */}
              <div>
                <label className="block text-sm font-medium text-neutral-700 mb-2">
                  URL de la Lista *
                </label>
                <div className="flex items-center gap-2 bg-neutral-50 border border-neutral-300 rounded-lg px-4 py-3">
                  <span className="text-neutral-500 text-sm whitespace-nowrap">
                    sobredigital.net/lista/
                  </span>
                  <input
                    type="text"
                    value={createFormData.customSlug}
                    onChange={(e) => setCreateFormData({
                      ...createFormData,
                      customSlug: sanitizeSlugInput(e.target.value),
                      slugDateOption: 'custom' // ✅ Cambiar a custom si editan manualmente
                    })}
                    required
                    className="flex-1 bg-transparent border-none focus:outline-none focus:ring-0 font-mono text-accent-600"
                    placeholder="maria-y-juan"
                  />
                </div>
                <p className="text-xs text-neutral-500 mt-1">
                  Solo letras minúsculas, números y guiones. Editá si hay duplicados.
                </p>
              </div>

              {/* Fecha del evento (para Firestore) */}
              <div>
                <label className="block text-sm font-medium text-neutral-700 mb-2">
                  Fecha del evento (para el sistema)
                </label>
                <input
                  type="date"
                  value={createFormData.weddingDate}
                  onChange={(e) => setCreateFormData({ ...createFormData, weddingDate: e.target.value })}
                  required
                  className="input-field"
                />
                <p className="text-xs text-neutral-500 mt-1">
                  Esta fecha se usará como referencia en el sistema.
                </p>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <p className="text-sm text-blue-900">
                  <strong>Próximo paso:</strong> Una vez creado el evento, se enviará un email a{' '}
                  <strong>{selectedRegistration.email}</strong> con las credenciales de acceso.
                  Los novios podrán completar la configuración en su panel.
                </p>
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowCreateModal(false)}
                  className="flex-1 btn-secondary"
                  disabled={creatingEvent}

                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className={`flex-1 btn-primary ${creatingEvent ? "opacity-60 cursor-not-allowed" : ""}`}
                  disabled={creatingEvent}
                >
                  {creatingEvent ? "Creando..." : "Crear Evento"}
                </button>

              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Eliminación */}
      {showDeleteModal && selectedCouple && (
        <div className="modal-overlay"
          onClick={() => {
            setShowDeleteModal(false);
          }}

        >
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-8 animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">⚠️</span>
              </div>
              <h2 className="text-2xl font-display font-bold text-neutral-900 mb-2">
                ¿Eliminar Pareja?
              </h2>
              <p className="text-neutral-600">
                Esta acción es <strong className="text-red-600">permanente</strong> y no se puede deshacer.
              </p>
            </div>

            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-red-900 mb-2">
                <strong>Pareja:</strong> {selectedCouple.brideName} & {selectedCouple.groomName}
              </p>
              <p className="text-sm text-red-900 mb-2">
                <strong>Email:</strong> {selectedCouple.email}
              </p>
              <p className="text-sm text-red-900">
                <strong>ID:</strong> {selectedCouple.id}
              </p>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-xs text-yellow-900">
                <strong>Se eliminarán:</strong>
              </p>
              <ul className="text-xs text-yellow-800 mt-2 space-y-1 list-disc list-inside">
                <li>El evento de la pareja</li>
                <li>Todos los regalos de su lista</li>
                <li>Todos los regalos recibidos</li>
                <li>Su cuenta de usuario</li>
                <li>Su acceso al sistema</li>
              </ul>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setSelectedCouple(null);
                }}
                className="flex-1 px-4 py-3 bg-neutral-100 text-neutral-700 rounded-lg font-semibold hover:bg-neutral-200 transition-colors"
              >
                Cancelar
              </button>
              <button
                onClick={handleDeleteCouple}
                className="flex-1 px-4 py-3 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors"
              >
                Sí, Eliminar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};



export default AdminPanel;
